__turbopack_context__.v({
  "dropdownWrapper": "menu-module-scss-module__z9g0ua__dropdownWrapper",
});
